import { render, staticRenderFns } from "./right-profile.vue?vue&type=template&id=208e9fc4&scoped=true"
import script from "./right-profile.vue?vue&type=script&lang=js"
export * from "./right-profile.vue?vue&type=script&lang=js"
import style0 from "./right-profile.vue?vue&type=style&index=0&id=208e9fc4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208e9fc4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\mrzhj\\Desktop\\ff\\frontent\\takeout\\www\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('208e9fc4')) {
      api.createRecord('208e9fc4', component.options)
    } else {
      api.reload('208e9fc4', component.options)
    }
    module.hot.accept("./right-profile.vue?vue&type=template&id=208e9fc4&scoped=true", function () {
      api.rerender('208e9fc4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/user/right-profile.vue"
export default component.exports